import { createSlice } from "@reduxjs/toolkit";

const defaultPageSize = localStorage.getItem("avoirs_pageSize_default") || process.env.REACT_APP_DEFAULT_PAGE_SIZE_LIST_INVOICE;

// `periodExported` est volontairement absent : « Exporté » n'existe pas dans le cycle de vie d'un
// avoir. L'ancien champ `period` a été retiré — il n'était lu par personne, ni ici ni côté backend.
// `extractionLvl`/`duplicated`/`digitalInvoice` ont suivi le 07/08 : les pastilles d'extraction
// sont retirées de l'écran Avoirs, et `fetchAvoirs` n'envoie plus ces champs.
export const initialAvoirFilter = {
	searchBy: "", status: [], startIssueDate: null, startSaveDate: null, startCreatedDate: null,
	endIssueDate: null, endSaveDate: null, endCreatedDate: null, pageNo: 0, pageSize: defaultPageSize,
	selectAll: false, sortBy: "", periodIntegrated: "", addressingKey: [],
};

const avoirFilter = createSlice({
	name: "avoirFilter",
	initialState: initialAvoirFilter,
	reducers: {
		updateAvoirFilter: (state, action) => action.payload,
		initAvoirFilter: () => initialAvoirFilter,
	},
});

export const { updateAvoirFilter, initAvoirFilter } = avoirFilter.actions;
export default avoirFilter.reducer;
